import React, { Component } from 'react';
import { Form, Radio, Button, Container, Progress, Header, Icon, Message, Image, Grid } from 'semantic-ui-react';
import { log } from '../../../Utilities/Utils'
import { Route, Switch, Link } from 'react-router-dom';
import { db, ref, firebaseStorage } from '../../../config/constants.js'
import FileUploader from 'react-firebase-file-uploader';
import numeral from 'numeral';
import { FormErrorsUi } from './FormErrors'

export function OrderProcessHeader(props) {
    return (

        <div>
            <Header as='h2' icon textAlign='center'>
                <Icon name={props.icon} circular />
                <Header.Content>
                    {props.headerText}
                </Header.Content>
            </Header>
        </div>

    )
}

export function ThankYou() {
    return (
        <h1> THANK YOU, YOU ORDER WILL SHIP IN AN HOUR </h1>
    )
}

export class UploadFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            progress: 0,
            isUploading: false,
            fileName: '',
            fileUrl: '',
            actualFileName: ''
        }
    }

    /**
     * HANDLE THE FILE UPLOADING..
     */
    // handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
    handleUploadStart = (file) => {
        console.log("fx1f file:" + file.name.split('.')[0]);
        this.setState({ isUploading: true, progress: 0, actualFileName: file.name });
    }


    // handleUploadSuccess = (fileName) => this.setState({fileName:fileName, isUploading: false, progress: 100});
    handleUploadSuccess = (saveFileName) => {
        console.log("ssss +++++++handleUploadSuccess");
        this.setState({ fileName: saveFileName, isUploading: false, progress: 100 });
        //  firebaseStorage.ref('docs').child(fileName).getDownloadURL().then(function(url){
        //      this.setState({fileUrl: url});
        //  }
        // );
        //UDPATE URL 
        let orderKey = this.props.fileName;
        firebaseStorage.ref('docs').child(saveFileName).getDownloadURL().then(
            url => {
                this.setState({ fileUrl: url })
                log("url is:" + url);

                // let tempRef = db.ref('orders').child(orderKey);
                // //UDPATE FIREBASE OBJECT WITH OBJECT NAME..
                // tempRef.update('fileUrl':url);

                let updates = {};
                updates['/orders/' + orderKey + '/fileUrl'] = url;
                updates['/orders/' + orderKey + '/fileName'] = saveFileName;
                updates['/orders/' + orderKey + '/usersFileName'] = this.state.actualFileName;
                // updates['/user-posts/' + uid + '/' + newPostKey] = postData;
                ref.update(updates);
            }
        );

        //complete file upload
        this.props.updateWhenFileUploadComplete(true, this.state.actualFileName);
    };

    //  firebase.storage().ref('images').child(filename).getDownloadURL().then(url => this.setState({avatarURL: url}));
    handleProgress = (progress) => this.setState({ progress });
    handleUploadError = (error) => {
        this.setState({ isUploading: false });
        console.error(error);
    }

    render() {

        const progressBarUI = (this.state.isUploading ? <Progress percent={this.state.progress} progress /> : "")

        return (
            <div>
                <FileUploader
                    accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                    name="avatar"
                    filename={this.props.fileName}
                    storageRef={firebaseStorage.ref('docs')}
                    onUploadStart={this.handleUploadStart}
                    onUploadSuccess={this.handleUploadSuccess}
                    onProgress={this.handleProgress}
                />
                {/* <h4>URL:{this.state.fileUrl}</h4> */}
                {/* <Progress percent={this.state.progress} progress /> */}
                {progressBarUI}
            </div>
        )
    }
}

export function Test(props) {
    console.log(props);
    return (

        <h2>testPassed, {props.poop}</h2>
    )
}

function BindingImage(props) {
    return (
        <div>
            <Image src={props.src} />
            <h3>{props.binding}</h3>
        </div>
    )
}


export class MainFormObject extends Component {
    constructor(props) {
        super(props);
        log("orx01 fuc OrderFormRadioButton constructor:" + this.props.checkValue);
    }

    render() {

        //console.log("shit:" + JSON.stringify(this.props.formErrors));

        const nameAndEmail = (
            <Form.Group widths='equal'>
                <OrderFormTextInput
                    label='Email'
                    fieldName='email'
                    value={this.props.emailValue}
                    handleChangeInMainComponent={this.props.handleChange}
                    maxLength='100'
                    inputType='email' />

                {/* PHONE */}
                <OrderFormTextInput
                    label='Phone'
                    fieldName='phone'
                    value={this.props.phoneValue}
                    handleChangeInMainComponent={this.props.handleChange}
                    maxLength='10'
                    inputType='number' />
            </Form.Group>
        )

        const numPagesAndNumCopies = (
            <Form.Group widths='equal'>
                <OrderFormTextInput
                    label='Number of Pages'
                    fieldName='numPages'
                    value={this.props.numPagesValue}
                    handleChangeInMainComponent={this.props.handleChange}
                    maxLength='3'
                    inputType='number' />

                <OrderFormTextInput
                    label='Number of Copies'
                    fieldName='numCopies'
                    value={this.props.numCopiesValue}
                    handleChangeInMainComponent={this.props.handleChange}
                    maxLength='3'
                    inputType='number' />
            </Form.Group>
        )


        const formErrorsConst = (
            this.props.formErrors === undefined ? <h3>no errors</h3>
                : <div>

                    <Message error>
                        <Message.Header>Error</Message.Header>
                        <Message.List>
                            {Object.keys(this.props.formErrors).map((fieldName, i) => {
                                //  console.log("fex1 fieldName:" + fieldName);
                                if (this.props.formErrors[fieldName].length > 0) {
                                    // console.log("fex12 fieldName length is greater than 0:");
                                    return (
                                        <Message.Item key={i}>{fieldName}>{this.props.formErrors[fieldName]}</Message.Item>
                                    )
                                } else {
                                    //  console.log("fex13 fieldName length is less than 0:");
                                    return '';
                                }
                            })}
                        </Message.List>
                    </Message >
                </div>
        )

        const nextButtonConst = (this.props.allFieldsValid ?
            <Button>
                <Link to={'/newOrder/confirmOrder'}>NEXT</Link>
            </Button>
            : <div>
                <p>FILL IN ALL FIELDS</p>
            </div>
        )

        const wire_image_src = require('../../../images/binding_wire.jpg');
        const booklet_image_src = require('../../../images/binding_booklet.jpg');
        const comb_image_src = require('../../../images/binding_comb.jpg');

        return (
            <div>
                <Container>
                    {/* <h1> ENTER NEW ORDER</h1> */}
                    <OrderProcessHeader icon='print' headerText='Enter New Order' />
                    <h3> TOTAL PRICE: {numeral(this.props.total).format('UGX 0,0')}</h3>

                    <Form onSubmit={this.props.handleSubmit} error={!this.props.allFieldsValid && !this.props.firstLoaded}>

                        {/* EMAIL AND NAME */}
                        {nameAndEmail}


                        {/* LOCATION */}
                        <OrderFormTextInput
                            label='Location'
                            fieldName='location'
                            value={this.props.locationValue}
                            handleChangeInMainComponent={this.props.handleChange} />

                        {/* num pages num copies */}

                        {numPagesAndNumCopies}

                        {/* DISPLAY TOTAL NUMBER OF PAGES */}
                        {/* <p>NUM PAGES:{this.props.totalNumpages}</p> */}

                        {formErrorsConst}

                        {/* BLACK WHITE RADIO GROUP */}
                        <BlackWhiteRadioGroup
                            checkValue={this.props.checkValue}
                            handleChangeInMainComponent={this.props.blackWhiteColorChangeHandler} />

                        {/* STAPLED RADIO GROUP */}
                        <StapledPaperClipRadioGroup
                            checkValue={this.props.looseStapled}
                            handleChangeInMainComponent={this.props.handleLooseStapledRadioChange} />

                        <BindingRadioGroup
                            checkValue={this.props.binding}
                            handleChangeInMainComponent={this.props.handleBindingChange} />

                        <Grid>
                            <Grid.Column width={4}>
                                <BindingImage binding='Wire' src={wire_image_src} />
                            </Grid.Column>

                            <Grid.Column width={4}>
                                <BindingImage binding='Booklet' src={booklet_image_src} />
                            </Grid.Column>

                            <Grid.Column width={4}>
                                <BindingImage binding='Comb' src={comb_image_src} />
                            </Grid.Column>
                        </Grid>

                        {/* <Image.Group size='tiny'>
                            {bindingImage}
                            {bindingImage}
                            <Image src={src} />
                            <Image src={src} />
                        </Image.Group> */}

                        {/* NEXT BUTTON */}
                        {nextButtonConst}
                    </Form>

                    {/* <Image src={src} />
                    <Image
                        src={require('../../../images/binding_wire.jpg')}
                    /> */}



                    {/* <Button onClick={this.props.formValidationFunction}>
                        NEW TEXT
                        </Button> */}

                    {/* {formErrorsConst} */}
                    {/* <FormErrorsUi formErrors={this.state.formErrors} /> */}

                </Container>

            </div >
        )
    }
}

// ---------: RADIO BUTTONS :--------------------
export function BindingRadioGroup(props) {
    // log("orx1 fuc OrderFormRadioButton constructor:" + props.checkValue);
    return (

        <Form.Group inline>
            <Form.Field>
                <h3>What kind of binding: <b>{props.checkValue}</b></h3>
            </Form.Field>

            {/* NONE RADIO BUTTON */}
            <OrderFormRadioButton
                label='None'
                name='bindingRadioGroup'
                value='none'
                checkValue={props.checkValue}
                handleChangeInMainComponent={props.handleChangeInMainComponent}
            />

            {/* Loose RADIO BUTTON */}
            <OrderFormRadioButton
                label='Loose'
                name='bindingRadioGroup'
                value='loose'
                checkValue={props.checkValue}
                handleChangeInMainComponent={props.handleChangeInMainComponent}
            />

            {/* Wire RADIO BUTTON */}
            <OrderFormRadioButton
                label='Wire'
                name='bindingRadioGroup'
                value='wire'
                checkValue={props.checkValue}
                handleChangeInMainComponent={props.handleChangeInMainComponent}
            />

            {/* Booklet RADIO BUTTON */}
            <OrderFormRadioButton
                label='Booklet'
                name='bindingRadioGroup'
                value='booklet'
                checkValue={props.checkValue}
                handleChangeInMainComponent={props.handleChangeInMainComponent}
            />

            {/* Comb RADIO BUTTON */}
            <OrderFormRadioButton
                label='Comb'
                name='bindingRadioGroup'
                value='comb'
                checkValue={props.checkValue}
                handleChangeInMainComponent={props.handleChangeInMainComponent}
            />


        </Form.Group>
    )
}


export function StapledPaperClipRadioGroup(props) {
    // log("orx1 fuc OrderFormRadioButton constructor:" + props.checkValue);
    return (

        <Form.Group inline>
            <Form.Field>
                <h3>Would you like stapled copies?: <b>{props.checkValue}</b></h3>
            </Form.Field>

            {/* STAPLED / YES RADIO BUTTON */}
            <OrderFormRadioButton
                label='Yes'
                name='looseStapled'
                value='stapled'
                checkValue={props.checkValue}
                handleChangeInMainComponent={props.handleChangeInMainComponent}
            />

            {/* LOOSE / NO RADIO BUTTON */}
            <OrderFormRadioButton
                label='No'
                name='looseStapled'
                value='loose'
                checkValue={props.checkValue}
                handleChangeInMainComponent={props.handleChangeInMainComponent}
            />
        </Form.Group>
    )
}


export function BlackWhiteRadioGroup(props) {
    // log("orx1 fuc OrderFormRadioButton constructor:" + props.checkValue);
    return (

        <Form.Group inline>
            <Form.Field>
                <h3>COLOR: <b>{props.checkValue}</b></h3>
            </Form.Field>

            {/* BLACK RADIO BUTTON */}
            <OrderFormRadioButton
                label='Black'
                name='blackWhiteColor'
                value='black'
                checkValue={props.checkValue}
                handleChangeInMainComponent={props.handleChangeInMainComponent}
            />

            {/* WHITE RADIO BUTTON */}
            <OrderFormRadioButton
                label='Color'
                name='blackWhiteColor'
                value='color'
                checkValue={props.checkValue}
                handleChangeInMainComponent={props.handleChangeInMainComponent}
            />
        </Form.Group>
    )
}

// RADIO BUTTON OBJECT
export class OrderFormRadioButton extends Component {
    constructor(props) {
        super(props);
        log("orx2 OrderFormRadioButton constructor:" + props.checkValue);
        this.handleChangeInsideComponent = this.handleChangeInsideComponent.bind(this);
    }

    handleChangeInsideComponent = (e, { name, value }) => {
        //handleChangeInsideComponent (e){
        log("inx1 button handleChangeInsideComponent ");
        log("inx12 value:" + value);
        log("inx13 name:" + name);
        this.props.handleChangeInMainComponent(e, { name, value });
    }

    render() {
        return (
            <Form.Field>
                <Radio
                    label={this.props.label}
                    name={this.props.name}
                    value={this.props.value}
                    checked={this.props.checkValue === this.props.value}
                    onChange={this.handleChangeInsideComponent}
                />
            </Form.Field>
        )
    }
}

// TEXT INPUT ORDER FORM
export class OrderFormTextInput extends Component {
    constructor(props) {
        super(props);
        this.handleChangeInsideComponent = this.handleChangeInsideComponent.bind(this);
    }

    handleChangeInsideComponent(e) {
        this.props.handleChangeInMainComponent(e);
    }

    render() {
        return (
            <Form.Field>
                <label>{this.props.label}</label>
                <input placeholder={this.props.fieldName}
                    name={this.props.fieldName}
                    value={this.props.value}
                    onChange={this.handleChangeInsideComponent}
                    maxLength={this.props.maxLength}
                // type={this.props.inputType}
                />
            </Form.Field>
        )
    }
}

export class EmailInput extends Component {
    constructor(props) {
        super(props);
        this.handleChangeInsideComponent = this.handleChangeInsideComponent.bind(this);
    }

    handleChangeInsideComponent(e) {
        log("ex1 handle input changed");
        //this.props.handleChangeInMainComponent(e.target.value);
        this.props.handleChangeInMainComponent(e);
        //log("ex12 input:"+(e.target.value));
    }

    render() {
        return (
            <Form.Field>
                <label>Email</label>
                <input placeholder='Email' name='email' onChange={this.handleChangeInsideComponent} />
            </Form.Field>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/orderProcess/orderFormComponents/OrderFormParts.js